<template>
    <div class="cadre">
        <h3>Fournisseur</h3>
        <table>
            <thead>
                <tr>
                    <th>Libellé</th>
                    <th>
                        <div class="tab_outils">
                            <div>
                                <a data-bs-toggle="modal" data-bs-target="#modalEditFournisseur"
                                    v-on:click="editFournisseur(null)">
                                    <i class="material-icons"
                                        style="font-size:20px;color:black; display: flex;justify-content: flex-end">add_circle</i>
                                </a>
                            </div>
                        </div>
                    </th>
                </tr>

            </thead>
            <tbody>
                <tr v-for="(fournisseur, index) in fournisseurs" :key="fournisseur.id">
                    <td>{{ fournisseur.libelle }}</td>
                    <td>
                        <div class="tab_outils">
                            <div>
                                <a v-on:click="viewStock(fournisseur.id)">
                                    <i class="material-icons"
                                        style="font-size:20px;color: cornflowerblue">visibility</i>
                                </a>
                            </div>
                            <div>
                                <a data-bs-toggle="modal" data-bs-target="#modalEditFournisseur"
                                    v-on:click="editFournisseur(fournisseur.id)">
                                    <i class="material-icons" style="font-size:20px;color:black">edit</i>
                                </a>
                            </div>
                            <div>
                                <a v-on:click="deleteFournisseur(index)">
                                    <i class="material-icons" style="font-size:20px;color:red">delete</i>
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <br />
    <div v-if="selectedFournisseurId" class="mouvement-stocks-section">
        <div class="cadre">
            <div class="h3_remove">
                <h3>Mouvement de stocks</h3>
                <a>
                    <i class="material-icons" style="font-size:20px;color:black" @click="closeListeStock">close</i>
                </a>
            </div>
            <table>
                <thead>
                    <tr>
                        <th>Quantité</th>
                        <th>Traitement</th>
                        <th>Date</th>
                    </tr>

                </thead>
                <tbody v-if="mouvementStocks && mouvementStocks.length">
                    <tr v-for="(mouvementStock, index) in paginatedItems" :key="mouvementStock.id">
                        <td>{{ mouvementStock.quantite }}</td>
                        <td :style="mouvementStock.typeTraitement == 'IN' ? 'color:green' : 'color:red'">{{
                            mouvementStock.typeTraitement }}</td>
                        <td>{{ this.format(mouvementStock.date) }}</td>
                    </tr>
                </tbody>
                <tfoot v-else>
                    <tr>
                        <td colspan="3" class="emptyTableMessage">Aucun mouvement de stock trouvé</td>
                    </tr>
                </tfoot>
            </table>
            <div class="pagination">

                <a v-on:click="previousPage()" :disabled="currentPage === 1">
                    <i class="material-icons" style="font-size:24px;">keyboard_double_arrow_left</i>
                </a>
                <span>Page {{ currentPage }} sur {{ totalPages }}</span>
                <a v-on:click="nextPage()" :disabled="currentPage === totalPages">
                    <i class="material-icons" style="font-size:24px;">keyboard_double_arrow_right</i>
                </a>
            </div>
        </div>
    </div>

    <FournisseurEdit :params="{ id: fournisseurId }" @saved="fetchFournisseur" />

</template>

<script>
import Axios from '@/services/axios.service';
import DateFormatService from '@/services/dateFormat.service';
import PaginationService from '@/services/pagination.service';
import FournisseurEdit from './FournisseurEdit.vue';

export default {
    name: 'FournisseurIndex',
    mixins: [PaginationService, DateFormatService],

    components: {
        FournisseurEdit,
    },
    data() {
        return {
            fournisseurs: [],
            fournisseurId: null,
            selectedFournisseurId: null,
        };
    },
    props: {
        msg: String
    },
    mounted() {
        this.fetchFournisseur();
    },
    methods: {
        fetchFournisseur() {
            Axios.get('/fournisseur/statut/ACTIF')
                .then(res => {
                    this.fournisseurs = res.data;
                })
                .catch(err => {
                    console.error('Erreur lors du chargement des fournisseurs :', err);
                });
        },
        deleteFournisseur(index) {
            Axios.delete('/fournisseur/' + this.fournisseurs[index].id)
                .then(response => {
                    if (response.status == 200) {
                        this.fournisseurs.splice(index, 1)
                    }
                })
                .catch(err => {
                    alert(err)
                })
        },
        editFournisseur(id) {
            this.fournisseurId = id;

        },

        //Affichage les livraison par fournisseur
        viewStock(id) {
            this.selectedFournisseurId = id;
            Axios.get(`/mouvementStock/fournisseur/${id}`)
                .then((res) => {
                    this.items = res.data
                    this.mouvementStocks = res.data
                }).catch(err => {
                    console.error('Erreur lors du chargement des livraions par fournisseur :', err);
                });
        },
    }
}
</script>

<style></style>